import { useState } from 'react'

import { EMPTY_STRING } from '../../constants/common'
import { useDebouncedState } from '../useDebouncedState'

export function useDebouncedSearch(timeout) {
  const [search, setSearch] = useState(EMPTY_STRING)

  const [debouncedSearch, setDebouncedSearch] = useDebouncedState(EMPTY_STRING)

  function handleChangeSearch({ target: { value } }) {
    setSearch(value)
    setDebouncedSearch(value, timeout)
  }

  function handleClearSearch() {
    setSearch(EMPTY_STRING)
    setDebouncedSearch(EMPTY_STRING)
  }

  return { debouncedSearch, handleChangeSearch, handleClearSearch, search }
}
